<template>
  <section class="section">
    <div class="container">
      <h1 class="title">
        Јавне набавке
      </h1>

      <p class="subtitle">Јавне набавке у дирекцији</p>
      <nav class="level" v-show="loggedIn">
        <div class="level-left">
          <p class="level-item">
            <router-link
              :to="{
                name: 'ResursForma',
                params: { id: null, tip: 'javna-nabavka' }
              }"
            >
              <b-button
                size="is-mediom"
                icon-pack="fas"
                icon-left="user"
                type="is-warning"
              >
                Нова јавна набавка
              </b-button>
            </router-link>
          </p>
        </div>
      </nav>
      <Resurs
        v-for="resurs in resursi"
        :key="resurs.id"
        :resurs="resurs"
        :izmenaDozvoljena="loggedIn"
      ></Resurs>

      <br />
      <!-- bulma je mnogo prostija -->
      <nav class="">
        <router-link
          :to="{ name: 'JavneNabavke', query: { page: page - 1 } }"
          class="button is-pulled-left"
          v-show="hasPrevPage"
          >&lt;&lt; Претходно</router-link
        >
        <router-link
          :to="{ name: 'JavneNabavke', query: { page: page + 1 } }"
          class="button is-pulled-right"
          v-show="hasNextPage"
          >Даље &gt;&gt;</router-link
        >
      </nav>
    </div>
    <Footer></Footer>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import Resurs from '../components/Resurs'
import Footer from '@/components/Footer.vue'

export default {
  components: {
    Resurs,
    Footer
  },
  data() {
    return {
      // filtri: {
      //   datum_od: '2020-01-01',
      //   datum_do: '2020-12-01'
      // }
    }
  },
  // created() {
  //   this.perPage = 3 // Setting perPage here and not in data means it won't be reactive.
  //   // We don't need it to be reactive, and this way our component has access to it.

  //   this.$store.dispatch('resursi/dajResurse', {
  //     type: 'javna-nabavka',
  //     perPage: this.perPage,
  //     page: this.page,
  //     filters: this.filtri
  //   })
  // },

  beforeRouteUpdate(to, from, next) {
    this.$store
      .dispatch('resursi/dajResurse', {
        type: 'javna-nabavka',
        perPage: this.$store.state.perPage,
        page: to.query.page,
        filters: {}
      })
      .then(() => {
        next()
      })
  },
  computed: {
    page() {
      return parseInt(this.$route.query.page) || 1
    },
    hasPrevPage() {
      return this.page !== 1
    },
    hasNextPage() {
      return this.resursaUkupno > this.page * this.$store.state.perPage
    },
    ...mapState('auth', ['loggedIn', 'userData']),
    ...mapState('resursi', ['resursi', 'resursaUkupno'])
  }
}
</script>

<style></style>
